import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const GanttIcon = (p: IconProps) => <Icon {...p}><path d="M4 6h4M4 10h10M4 14h6M4 18h14" /></Icon>
